import React from 'react';
// import PropTypes from 'prop-types';

export const TopNav = () => {
    return (
      <div className="topNav__placeholder">
          <div className="topNav__inner">
            <div className="left">LEFT</div>
            <div className="center">CENTER</div>
            <div className="right">RIGHT</div>
          </div>
      </div>
    );
};

TopNav.propTypes = {

}
